import { Cookies } from '../services';

const getIdentifierFromAuthToken = () => {
  const cvLimitedAccessToken = Cookies.get('CVLimitedAccessToken');
  if (!cvLimitedAccessToken) return null;
  const parsedToken = JSON.parse(cvLimitedAccessToken);
  const identifier = parsedToken?.user;
  return identifier;
}

export default getIdentifierFromAuthToken;
